import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useDateTimePickerStyles = createUseStyles({
  dateTimePicker: {
    height: 40,
    width: '100%',
    padding: '6px 12px',
    borderWidth: 1,
    borderColor: '#ddd',
    borderStyle: 'solid',
    borderRadius: 4,
    color: colors.text,
    backgroundColor: '#fff',

    '&:focus': {
      outline: 0,
      borderColor: colors.primary1,
      boxShadow: `0px 0px 0px 1px ${colors.primary1}`
    }
  }
})

export { useDateTimePickerStyles }
